<template>
  <header
    class="component"
    id="product_detail_header"
    role="banner"
    aria-label="Product header"
    v-loading="!product.hasDetail"
    :style="{ top: topOffset + 'px' }"
  >
    <div class="page--container">
      <el-row type="flex" align="middle" :gutter="30">
        <el-col :span="20">
          <product-category-breadcrumb
            :product="product"
          ></product-category-breadcrumb>
          <h1 class="product__title">{{ product.title }}</h1>
        </el-col>
        <el-col :span="4">
          <el-button-group>
            <el-button
              @click="handleToggleFavorite"
              :class="{ active: isFavorite }"
              type="text"
            >
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path :d="starIconFilled" fill="currentColor" />
              </svg>
              <!--TODO Added new translation string "Add to Favorites" to Product section.-->
              <span class="sr-only sr-only-focusable">{{
                $t('productCardFavorite')
              }}</span>
            </el-button>
            <el-button
              v-if="supportedFeaturesOutbox"
              @click="handleAttachAll"
              :class="{ active: isAttached }"
              type="text"
            >
              <i class="el-icon-custom-attach">
                <!--TODO Added new translation string "Add to Outbox" to Product section.-->
                <span class="sr-only sr-only-focusable">{{
                  $t('productCardAttach')
                }}</span>
              </i>
            </el-button>
          </el-button-group>
        </el-col>
      </el-row>
    </div>
  </header>
</template>

<script>
import ProductCategoryBreadcrumb from './ProductCategoryBreadcrumb.vue';
import user from '@/components/user';
import outbox from '@/components/outbox';
import { mapActions, mapGetters, mapState } from 'vuex';
import mixins from '@/mixins';
import { starIconFilled } from '../../assets/icon-paths/star-icon';

export default {
  name: 'ProductDetailHeader',
  mixins: [mixins.supportedFeatures],
  data() {
    return {
      topOffset: 0,
    };
  },
  props: {
    product: {
      type: Object,
    },
  },
  computed: {
    ...mapState(user.store.namespace, ['currentUser']),
    ...mapState(outbox.store.namespace, ['assets']),
    ...mapGetters(user.store.namespace, ['region']),
    isFavorite,
    isAttached() {
      return !!this.assets[this.product.id];
    },
    starIconFilled() {
      return starIconFilled;
    },
  },
  methods: {
    ...mapActions(user.store.namespace, ['toggleFavorite']),
    ...mapActions(outbox.store.namespace, ['attachAllForProduct']),
    handleAttachAll() {
      this.attachAllForProduct(this.product);
    },
    handleToggleFavorite() {
      this.toggleFavorite(this.product.id);
    },
    handleWindowResize() {
      this.topOffset = document.getElementById('app-header').offsetHeight;
    },
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  },
  components: {
    'product-category-breadcrumb': ProductCategoryBreadcrumb,
  },
};

//////////

function isFavorite() {
  let currentUser = this.currentUser; // keep this to have Vue watch favorites change.
  return this.$store.getters[`${user.store.namespace}/productIsFavorite`](
    Number(this.product.id)
  );
}
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';

.component {
  position: static;
  z-index: 50;
  left: 0;
  right: 0;
  background: #f0f0f0;
  padding: 20px 0;

  @include res(md) {
    position: sticky;
    top: 0 !important;
  }
}

.product__title {
  margin: 10px 0 0;
}

.el-button-group {
  float: right;
  text-align: center;

  .el-button {
    width: 48px;
    font-size: 20px;
    color: #aaaaaa;

    &.active {
      color: #ed1c2e;
    }
  }
}
</style>
